import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../services/storage.service';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-verify',
    standalone: true,
    imports: [],
    templateUrl: './verify.component.html',
    styleUrl: './verify.component.scss',
})
export class VerifyComponent {
    token?: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toaster: ToastrService,
        private authService: AuthService,
        private storageService: StorageService,
        private translationService: TranslationService
    ) {}

    async ngOnInit() {
        this.route.params.subscribe(async (params: Params) => {
            this.token = params['token'];

            await this.verifyAccount();
        });
    }

    async verifyAccount() {
        if (this.token === undefined) {
            return;
        }

        try {
            let response = await firstValueFrom(
                this.authService.verifyToken(this.token)
            );
            this.storageService.setToken(response.token.access_token);
            const user = await firstValueFrom(
                this.authService.getUserInfoOrRefreshIfNeeded()
            );

            if (user.is_first_connection) {
                this.router.navigate(['/onboarding/1']);
            } else {
                this.router.navigate(['']);
            }
        } catch (error) {
            const errorMessage = this.translationService.instant(
                'errors.network.serverError'
            );
            const errorTitle = this.translationService.instant(
                'common.labels.error'
            );
            this.toaster.error(errorMessage, errorTitle);
        }
    }
}
